<template>
 <v-content class="tour-ai-dashboard">
    <v-container grid-list-xl style="padding-block: 10px; margin-top: 30px">
  <v-card dark class="card-animate-2">
          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="150"
            height="125"
            elevation="3"
            dense
          >
            <v-toolbar-title>
              <v-avatar size="40">
                                <img src="@/assets/Concierge.png">
                        </v-avatar>
              Tour Router
            </v-toolbar-title>
       
          <v-spacer></v-spacer>

          <v-chip class="ml-2" color="#00ffe5" text-color="black">Google</v-chip>
          <v-chip class="ml-2" color="#00ffe5" text-color="black">Ticketmaster</v-chip>
          <v-chip class="ml-2" color="#00ffe5" text-color="black">Spotify</v-chip>
          <v-chip class="ml-2" color="#00ffe5" text-color="black">OpenAI</v-chip>
        </v-app-bar>
        </v-card>  
        <br />
        <br />
            <!-- STEPPER -->
                     <div       
            class="saved-tours card-animate-2 theme-bg-card-5">
      <v-stepper v-model="step" vertical>
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">Artist</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2">Origin & Venue</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 3" step="3">Cities & Dates</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4">Plan & Export</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <!-- STEP 1 -->
          <v-stepper-content step="1">
            <v-card class="step-card">
              <h3>Step 1 — Add Artist</h3>
              <v-text-field
                v-model="artistName"
                label="Artist Name"
                outlined dense
                color="primary"
              ></v-text-field>
              <v-btn color="primary" @click="nextStep(2)" class="mt-4">Next</v-btn>
            </v-card>
          </v-stepper-content>

          <!-- STEP 2 -->
          <v-stepper-content step="2">
            <v-card class="step-card">
              <h3>Step 2 — Origin & Venue Size</h3>
              <v-text-field
                v-model="originCity"
                label="Starting City"
                outlined dense
                color="primary"
              ></v-text-field>
              <v-text-field
                v-model="venueSize"
                label="Venue Size"
                outlined dense
                color="primary"
              ></v-text-field>
              <v-btn color="primary" @click="nextStep(3)" class="mt-4">Next</v-btn>
            </v-card>
          </v-stepper-content>

          <!-- STEP 3 -->
          <v-stepper-content step="3">
            <v-card class="step-card">
              <h3>Step 3 — Add Cities & Dates</h3>
              <div v-for="(city, index) in cities" :key="index" class="city-input-row">
                <v-text-field
                  v-model="city.name"
                  label="City"
                  outlined dense
                ></v-text-field>
                <v-text-field
                  v-model="city.date"
                  type="date"
                  label="Date"
                  outlined dense
                ></v-text-field>
                <v-btn icon @click="removeCity(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
 <button @click="addCity" class="add-btn">➕ Add City</button>
              <v-btn color="primary" @click="nextStep(4)" class="mt-4">Next</v-btn>
            </v-card>
          </v-stepper-content>

          <!-- STEP 4 -->
          <v-stepper-content step="4">
            <v-card class="step-card">
              <h3>Step 4 — Plan Tour & Export</h3>
              <v-btn
                color="primary"
                @click="planTour"
                :loading="loading"
                class="mr-2"
              >
                🎟️ {{ loading ? 'Planning...' : 'Generate Tour Route' }}
              </v-btn>
              <v-btn class="mr-2" @click="saveTour">💾 Save</v-btn>
              <v-btn @click="generatePDF">📄 PDF</v-btn>

              <v-divider class="my-4"></v-divider>
              <div id="tour-map" style="height: 400px;"></div>
              <br />
              <div v-if="aiNotification" class="ai-notification">
                <p>{{ aiNotification }}</p>
              </div>
              <div v-if="optimizedTourDates.length" class="optimized-dates">
                <h4>📅 AI-Optimized Tour Dates:</h4>
                <ul>
                  <li v-for="(date, index) in optimizedTourDates" :key="index">
                    {{ date.name }} - {{ date.date }}
                  </li>
                </ul>
              </div>
              <br />
              <br />
<div v-if="tourReport" class="tour-report">
  <div class="report-header">
    <h4>🎤 AI Tour Execution Report</h4>
  </div>
  <div class="report-body"> </div>
  <p><strong>Artist:</strong> {{ artistName }}</p>
  <p><strong>Starting City:</strong> {{ originCity }}</p>
  <p><strong>Venue Size:</strong> {{ venueSize }} Capacity</p>
  <p v-html="tourReport" class="report-content"></p>
  <button @click="downloadReport" class="download-btn">📄 Download Report</button>
  </div>
              <!-- <div v-if="tourReport" class="mt-4">
                <h4>📄 AI Tour Report</h4>
                <p v-html="tourReport"></p>
              </div> -->
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
      <br />
        <v-card             
            color="rgba(12, 22, 27)"
            elevation="3"
            dense
            dark class="card-animate-2">
          <br />
          <br />
          <br />
        <div v-if="artistProfiles.length" class="artist-profiles">
               <div
                 v-for="(profile, index) in artistProfiles"
                 :key="index"
                 class="profile-card2"
                 @click="selectArtistProfile(index)"
                 :class="{ expanded: expandedIndex === index }"
               >
                 <div class="album-container">
                   <!-- Album Cover -->
                   <div class="album-cover">
                    <section v-if="artistData">

        <img :src="artistData.images[0]?.url" class="cover-image2" />
      </section>
                     <img :src="profile.image" class="cover-image2" />
                   </div>
                   <!-- Vinyl Record -->
                   <div
                     class="vinyl-record"
                     :class="{ 'slide-out': expandedIndex === index }"
                   >
                     <img
                       src="https://gallery.yopriceville.com/var/resizes/Free-Clipart-Pictures/Music-PNG/Gramophone_Vinyl_LP_Record_PNG_Transparent_Clip_Art_Image.png"
                       alt="Vinyl Record"
                       class="vinyl-image"
                     />
                   </div>
                 </div>
                 <!-- Artist Information -->
                 <h3>{{ profile.artistName }}</h3>
          
          
                 <v-btn small @click.stop="editArtistProfile(index)">Edit</v-btn>
                 <v-btn small color="red" @click.stop="deleteArtistProfile(index)">Delete</v-btn>
               </div>
             </div>

    <!-- Artist Profiles Section -->
    <!-- <div v-if="artistProfiles.length" class="artist-profiles">
      <div class="artist-list">
        <div
          v-for="(profile, index) in artistProfiles"
          :key="index"
          class="profile-card"
          @click="selectArtistProfile(index)"
        >
          <div class="album-container">
            <div class="album-cover">
              <img v-if="profile.image" :src="profile.image" class="cover-image" />
              <img v-else src="https://via.placeholder.com/150" class="cover-image" />
            </div>
          </div>
          <h4>{{ profile.artistName }}</h4>
        </div>
      </div>
    </div> -->
    <br />
    <br />
    <br />

  <!-- Artist & Origin Input -->
  <!-- <div class="input-group">
      <h3>Step 1 : Add artist</h3>
      <input v-model="artistName" placeholder="Artist Name (e.g., The Weeknd)" class="input-box" />
    </div>
    <div class="input-group">
      <h3>Step 2 : Starting City</h3>
      <input v-model="originCity" placeholder="Starting City (e.g., New York, NY)" class="input-box" />
    </div> -->



    <!-- Input: Venue Size -->
    <!-- <div class="input-group">
      <h3>Step 3 : Venue Size</h3>
      <input v-model="venueSize" placeholder="Venue Size (e.g., 500 people)" class="input-box" />
    </div>
<br /> -->


<!-- Start & End Date Inputs (Shown When AI Optimization is Active) -->
<div v-if="isOptimizingTour || optimizedTourDates.length" class="tour-date-inputs">
  <h4>📅 AI-Optimized Tour Dates:</h4>
  <input v-model="startDate" type="date" class="input-box" placeholder="Tour Start Date" />
  <input v-model="endDate" type="date" class="input-box" placeholder="Tour End Date" />
</div>

<br />
    <!-- Input: Cities and Dates -->
    <!-- <h3>Step 4 : Add Cities and Dates</h3>
    <div class="city-list">
      <div v-for="(city, index) in cities" :key="index" class="city-input">
        <input v-model="city.name" placeholder="City (e.g., Los Angeles, CA)" class="input-box" />
        <input v-model="city.date" type="date" class="input-box" />
        <button @click="removeCity(index)" class="remove-btn">❌</button>
      </div>
      <br />
<v-divider dark></v-divider>
      <button @click="addCity" class="add-btn">➕ Add City</button>
    </div>
<br /> -->

    <v-divider dark></v-divider>
    <!-- <br />

    <button @click="planTour" :disabled="loading" class="ask-button">
  🎟️ {{ loading ? "Planning..." : "Generate Tour Route" }}
</button>
    <button @click="saveTour" class="ask-button mr-10">💾 Save Tour</button>
    <button @click="generatePDF" class="ask-button">📄 Generate PDF</button>
    <br />
<br />
<br /> -->
  </v-card>
  <!-- <br />
  <br />
  <div id="tour-map"></div>
    <br />
    <br /> -->
    <div v-if="venues.length" class="venue-results">
      <h4>🎤 Planned Tour Venues:</h4>
      <ul>
        <li v-for="(venue, index) in venues" :key="index">
          <strong>{{ venue.name }}</strong> - {{ venue.location }} (Capacity: {{ venue.capacity }})
          <v-btn :href="venue.url" target="_blank" class="venue-link">🌐 View</v-btn>
          <button @click="removeVenue(index)" class="remove-btn">🗑 Delete</button>
        </li>
      </ul>
      <button @click="saveTour" class="save-btn mr-10">💾 Save Tour</button>
      <button @click="generatePDF" class="save-btn">📄 Generate PDF</button>
    </div>
    <v-card             
            color="rgba(12, 22, 27)"
            elevation="3"
            dense
            dark class="card-animate-2">
          <br />
          <br />
          <br />
    <!-- Ask AI a Question -->
    <div class="ai-question">
      <input v-model="userQuestion" placeholder="Ask AI about your event..." class="input-box" />
      <button @click="askAI" :disabled="loading" class="ask-button">Ask AI</button>
    </div>
    <p v-if="aiResponse" class="ai-response">{{ aiResponse }}</p>
    <br />
    <v-icon :color="recordingStateColor">mdi-microphone</v-icon>

<v-btn class="btn btn-primary mb-4" @click="promptUserAndStartRecording" v-if="!isRecording">Start</v-btn>
<v-btn class="btn btn-primary mb-4" @click="stopRecording" v-if="isRecording">Listening</v-btn>
    <br /> 
  </v-card>
    <br />
<!-- Tour Venues -->


<br />
<br />
<!-- <div id="tour-map"></div>
<br />
<br /> -->

    <!-- Saved Tours -->
    <div v-if="savedTours.length" class="saved-tours">
      <h3>📅 Saved Tours</h3>
      <ul>
        <li v-for="(tour, index) in savedTours" :key="index">
          <strong>Tour {{ index + 1 }}:</strong> {{ tour.venueSize }} Capacity, {{ tour.cities.length }} cities
          <button @click="loadTour(index)" class="edit-btn">✏ Edit</button>
          <button @click="deleteTour(index)" class="remove-btn">🗑 Delete</button>
        </li>
      </ul>
    </div>
    <br />
    <br />
  </v-container>
  </v-content>
</template>

<script>
import axios from "axios";
import stadiums from "@/data/stadiums.json";
import jsPDF from "jspdf";
// import { saveAs } from "file-saver";
// import { Document, Packer, Paragraph } from "docx";

export default {
  data() {
    return {
        step: 1,
      artistProfiles: JSON.parse(localStorage.getItem("artistProfiles")) || [],
      artistName: "",
      originCity: "",
      venueSize: "",
      cities: [{ name: "", date: "" }],
      startDate: "",
    endDate: "",
    isRecording: false,
    recordingStateColor: 'green', // Default color
    optimizedTourDates: [],
    isOptimizingTour: false,
    aiNotification: "",
      venues: [],
      savedTours: [],
      loading: false,
      userQuestion: "",
      aiResponse: "",
      gptApiKey: "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", // Replace with your OpenAI API key
      googleApiKey: "AIzaSyBboVjZMYbpCulM_NhAuW5I_e6ZwD5f8qA", // Replace with your Google API key
      map: null,
      directionsService: null,
      directionsRenderer: null
    };
  },
  mounted() {
    this.loadSavedTours();
    window.initMap = this.displayGoogleMap;
    setTimeout(() => {
      this.promptUserAndStartRecording();
    }, 5000);
  },
  methods: {
    promptUserAndStartRecording() {
      // Use speech synthesis to ask the user what they want to create
      this.speakNotification('What would you like me to do?');
      window.scrollTo({ top: 700, behavior: 'smooth' });
      // Wait for 2 seconds after the question, then start recording
      setTimeout(() => {
      this.isRecording = true;
      this.recordingStateColor = 'green'; // Color when recording starts
      this.startRecording();
    }, 2000);
    },
      nextStep(next) {
      this.step = next;
    },
    addCity() {
      this.cities.push({ name: "", date: "" });
    },
    removeCity(index) {
      this.cities.splice(index, 1);
    },
    // planTour() {
    //   if (!this.venueSize || !this.originCity || this.cities.some(city => !city.name || !city.date)) {
    //     alert("Please enter all required fields.");
    //     return;
    //   }

    //   this.loading = true;
    //   this.venues = this.findMatchingVenues();
    //   this.loadGoogleMapsAPI();
    //   this.loading = false;
    // },
    selectArtistProfile(index) {
      const profile = this.artistProfiles[index];
      this.artistName = profile.artistName;
      this.speakNotification(`Selected artist: ${profile.artistName}`);
    },

    async optimizeTourRoute() {
    if (this.cities.length < 2) {
      alert("Add at least two cities to optimize the tour route.");
      return;
    }

    this.isOptimizingTour = true;
    this.speakNotification("Optimizing the best tour route based on price and efficiency...");

    const tourData = {
      artist: this.artistName,
      cities: this.cities.map((c) => c.name),
      venueSize: this.venueSize,
      startingCity: this.originCity,
    };

    try {
      const response = await axios.post("https://api.openai.com/v1/chat/completions", {
        model: "gpt-4.1",
        messages: [{ role: "user", content: `Determine the best tour dates for ${JSON.stringify(tourData)}.` }],
        max_tokens: 8000,
        temperature: 0.2,
      }, {
        headers: { Authorization: `Bearer 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`, "Content-Type": "application/json" },
      });

      const aiResult = response.data.choices[0].message.content.trim();
      this.processOptimizedDates(aiResult);
    } catch (error) {
      console.error("AI Optimization Error:", error);
      this.speakNotification("Error optimizing the tour route.");
    } finally {
      this.isOptimizingTour = false;
    }
  },

  processOptimizedDates(aiResult) {
    const optimizedDates = JSON.parse(aiResult); // Ensure AI returns JSON formatted results

    this.startDate = optimizedDates.startDate;
    this.endDate = optimizedDates.endDate;
    this.optimizedTourDates = optimizedDates.cities;

    this.cities.forEach((city, index) => {
      if (optimizedDates.cities[index]) {
        city.date = optimizedDates.cities[index].date;
      }
    });

    this.speakNotification("Tour route optimization complete.");
    this.scrollToSection("tour-map-section");
  },
  speakNotification(message) {
  this.aiNotification = message;

  if (!("speechSynthesis" in window)) {
    console.warn("Speech Synthesis API is not supported in this browser.");
    return;
  }

  const speech = new SpeechSynthesisUtterance(message);
  const voices = window.speechSynthesis.getVoices();

  // Select the preferred voice
  const preferredVoice = voices.find(voice => voice.name === "Google UK English Female");
  const fallbackVoice = voices.find(voice => voice.lang.includes('en-GB') && voice.name.includes("Google"));

  // Assign voice, pitch, rate, and volume
  speech.voice = preferredVoice || fallbackVoice || voices[0];
  speech.pitch = 1;
  speech.rate = 1;
  speech.volume = 1;

  // Speak the message
  window.speechSynthesis.speak(speech);

  // Optional: Clear notification after 5 seconds
  setTimeout(() => (this.aiNotification = ""), 5000);
},

//   speakNotification(message) {
//     this.aiNotification = message;
//     if ("speechSynthesis" in window) {
//       const speech = new SpeechSynthesisUtterance(message);
//       speech.voice = speechSynthesis.getVoices().find((v) => v.name.includes("Google"));
//       speechSynthesis.speak(speech);
//       const voices = window.speechSynthesis.getVoices();

// // Select the preferred voice
// const preferredVoice = voices.find(voice => voice.name === "Google UK English Female");
// const fallbackVoice = voices.find(voice => voice.lang.includes('en-GB') && voice.gender === 'female');

// // Assign voice, pitch, rate, and volume
// speech.voice = preferredVoice || fallbackVoice || voices[0];
// speech.pitch = 1;
// speech.rate = 1;
// speech.volume = 1;
//     }
//     setTimeout(() => (this.aiNotification = ""), 5000);
//   },
    async getArtistProfiles() {
      try {
        const response = await axios.get("https://api.spotify.com/v1/search", {
          headers: {
            Authorization: `Bearer ${this.accessToken}`,
          },
          params: {
            q: this.artistName,
            type: "artist",
            limit: 5,
          },
        });
        this.artistProfiles = response.data.artists.items.map((artist) => ({
          artistName: artist.name,
          image: artist.images.length ? artist.images[0].url : null,
        }));
        localStorage.setItem("artistProfiles", JSON.stringify(this.artistProfiles));
      } catch (error) {
        console.error("Error fetching artist profiles:", error);
      }
    },
    async planTour() {
  if (!this.venueSize || !this.originCity || this.cities.some(city => !city.name || !city.date)) {
    alert("Please enter all required fields.");
    return;
  }

  this.loading = true;
  this.venues = this.findMatchingVenues();
  this.loadGoogleMapsAPI();
  this.speakNotification("Generating a detailed report for the optimal execution of this tour...");
  // Generate AI-powered report
  const fullPrompt = `
    Generate a detailed report for the optimal execution of this tour. 
    Artist: ${this.artistName}
    Starting City: ${this.originCity}
    Venue Size: ${this.venueSize}
    Cities and Dates: ${this.cities.map(c => `${c.name} on ${c.date}`).join(", ")}
    Matching Venues: ${this.venues.map(v => v.name).join(", ")}
    
    Please include:
    - Optimal tour execution strategy
    - Recommended travel routes & times
    - Suggested leaving, load-ins, load-outs
    - Backup venue options
    - Best dates for tour execution based on logistics and travel time.
  `;

  try {
    this.tourReport = "Generating report...";
    this.tourReport = await this.askChatGPT(fullPrompt);
  } catch (error) {
    console.error("Error fetching AI report:", error);
    this.tourReport = "Failed to generate report. Please try again.";
  }

  this.loading = false;
},
    findMatchingVenues() {
      return this.cities.map(city => {
        let bestMatch = stadiums.find(
          stadium => stadium.location.includes(city.name) && stadium.capacity >= parseInt(this.venueSize)
        );
        return bestMatch ? {
          name: bestMatch.name,
          location: bestMatch.location,
          capacity: bestMatch.capacity,
          url: bestMatch.website
        } : null;
      }).filter(venue => venue !== null);
    },
    saveTour() {
      this.savedTours.push({
        artist: this.artistName,
        origin: this.originCity,
        venueSize: this.venueSize,
        cities: [...this.cities],
        venues: [...this.venues]
      });
      localStorage.setItem("savedTours", JSON.stringify(this.savedTours));
      alert("Tour saved!");
    },
    loadSavedTours() {
      const tours = localStorage.getItem("savedTours");
      if (tours) this.savedTours = JSON.parse(tours);
    },
    loadTour(index) {
      const tour = this.savedTours[index];
      this.artistName = tour.artist;
      this.originCity = tour.origin;
      this.venueSize = tour.venueSize;
      this.cities = tour.cities;
      this.venues = tour.venues;
    },
    deleteTour(index) {
      this.savedTours.splice(index, 1);
      localStorage.setItem("savedTours", JSON.stringify(this.savedTours));
    },
    generatePDF() {
      const doc = new jsPDF();
      doc.text("Event Tour Report", 10, 10);
      doc.text(`Artist: ${this.artistName}`, 10, 20);
      doc.text(`Starting City: ${this.originCity}`, 10, 30);
      doc.text(`Venue Size: ${this.venueSize}`, 10, 40);

      this.venues.forEach((venue, index) => {
        doc.text(`${index + 1}. ${venue.name} - ${venue.location} (Capacity: ${venue.capacity})`, 10, 50 + index * 10);
      });

      doc.save("event-tour.pdf");
    },
    downloadReport() {
  const doc = new jsPDF();
  doc.text("AI Tour Execution Report", 10, 10);
  doc.text(this.tourReport, 10, 20);
  doc.save("Tour-Execution-Report.pdf");
},

// async downloadReport() {
//   if (!this.tourReport) {
//     alert("No report available to download.");
//     return;
//   }

//   const doc = new Document({
//     sections: [
//       {
//         properties: {},
//         children: [
//           new Paragraph({
//             text: "🎤 AI Tour Execution Report",
//             heading: "Heading1",
//             alignment: "CENTER",
//           }),
//           new Paragraph({ text: "Artist: " + this.artistName, spacing: { after: 200 } }),
//           new Paragraph({ text: "Starting City: " + this.originCity, spacing: { after: 200 } }),
//           new Paragraph({ text: "Venue Size: " + this.venueSize + " Capacity", spacing: { after: 200 } }),
//           new Paragraph({ text: "Tour Details:", heading: "Heading2" }),
//           new Paragraph({ text: this.tourReport, spacing: { after: 400 } }),
//         ],
//       },
//     ],
//   });

//   const blob = await Packer.toBlob(doc);
//   saveAs(blob, "Tour_Execution_Report.docx");
  
// },
    loadGoogleMapsAPI() {
      if (typeof google === "undefined") {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.googleApiKey}&callback=initMap`;
        script.defer = true;
        script.async = true;
        document.head.appendChild(script);
      } else {
        this.displayGoogleMap();
      }
    },
    displayGoogleMap() {
      if (!this.map) {
        this.map = new window.google.maps.Map(document.getElementById("tour-map"), {
          center: { lat: 37.7749, lng: -122.4194 },
          zoom: 5,
        });
        this.directionsService = new window.google.maps.DirectionsService();
        this.directionsRenderer = new window.google.maps.DirectionsRenderer();
        this.directionsRenderer.setMap(this.map);
      }

      if (this.venues.length > 1) {
        const waypoints = this.venues.slice(1, -1).map(venue => ({ location: venue.location, stopover: true }));
        const request = {
          origin: this.venues[0].location,
          destination: this.venues[this.venues.length - 1].location,
          waypoints: waypoints,
          travelMode: "DRIVING"
        };
        this.directionsService.route(request, (result, status) => {
          if (status === "OK") {
            this.directionsRenderer.setDirections(result);
          }
        });
      }
    },
    
   startRecording() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.start();

    recognition.onstart = () => {
      this.recordingStateColor = 'blue'; // Color when user is speaking
    };

    recognition.onresult = (event) => {
    
      this.userQuestion = event.results[0][0].transcript;
      this.recordingStateColor = 'red'; // Color just before submitting
      setTimeout(() => {
        this.askAI();
        this.isRecording = false;
        this.recordingStateColor = 'blue'; // Reset color after submitting
      }, 1000);
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event);
      this.isRecording = false;
    };

    this.isRecording = true;
  },


  stopRecording() {
    this.isRecording = false;
    this.recordingStateColor = 'blue'; // Reset color when stopped
    // Logic to stop recording. This depends on your implementation of SpeechRecognition.
    // If you've stored the instance of SpeechRecognition in a variable, call stop() on it.
  },
  async askAI() {
    
    if (!this.userQuestion.trim()) {
      alert("Please enter a question.");
      return;
    }

    if (this.userQuestion.toLowerCase().includes("update route")) {
      return this.updateRoute();
    }
                                                                                                                   
    const fullPrompt = `Here is the planned event: 
    - Venue Size: ${this.venueSize} 
    - Cities: ${this.cities.map(c => `${c.name} on ${c.date}`).join(", ")}
    - Venues: ${this.venues.map(v => v.name).join(", ")}.
    Answer the following: ${this.userQuestion}`;

    this.aiResponse = "Thinking...";
    try {
      this.aiResponse = await this.askChatGPT(fullPrompt);
    } catch (error) {
      this.aiResponse = "Error fetching response.";
      console.error(error);
    }
  },
  async updateRoute() {
    this.aiResponse = "Updating route...";

    const fullPrompt = `
    Update the event tour route based on these details:
    - Artist: ${this.artistName}
    - Origin City: ${this.originCity}
    - Venue Size: ${this.venueSize}
    - Cities and Dates: ${this.cities.map(c => `${c.name} on ${c.date}`).join(", ")}
    - Planned Venues: ${this.venues.map(v => v.name).join(", ")}
    
    Include:
    - Optimal routing with better efficiency
    - Suggested updates for travel time and logistics
    - Revised venue recommendations if necessary
    - Adjusted dates for best execution
    - Any conflicts or potential improvements`;

    try {
      const updatedResponse = await this.askChatGPT(fullPrompt);
      this.aiResponse = updatedResponse;

      // Parse response and update fields dynamically
      this.processOptimizedRoute(updatedResponse);
    } catch (error) {
      console.error("Error updating route:", error);
      this.aiResponse = "Failed to update route. Try again.";
    }
  },

  processOptimizedRoute(response) {
    // Parse the response and update the form data
    try {
      const updatedData = JSON.parse(response);

      this.startDate = updatedData.startDate || this.startDate;
      this.endDate = updatedData.endDate || this.endDate;
      this.cities = updatedData.cities || this.cities;
      this.venues = updatedData.venues || this.venues;

      this.speakNotification("Route updated successfully.");
    } catch (error) {
      console.error("Error processing updated route:", error);
    }
  },
    // async askAI() {
    //   if (!this.userQuestion.trim()) {
    //     alert("Please enter a question.");
    //     return;
    //   }

    //   const fullPrompt = `Here is the planned event: Venue Size: ${this.venueSize}, Cities: ${this.cities.map(c => `${c.name} on ${c.date}`).join(", ")}, Venues: ${this.venues.map(v => v.name).join(", ")}. Answer the following: ${this.userQuestion}`;
      
    //   this.aiResponse = "Thinking...";
    //   try {
    //     this.aiResponse = await this.askChatGPT(fullPrompt);
    //   } catch (error) {
    //     this.aiResponse = "Error fetching response.";
    //     console.error(error);
    //   }
    // },
    async askChatGPT(prompt) {
   const response = await axios.post(
     "https://api.openai.com/v1/chat/completions",
     {
       model: "gpt-4.1",
       messages: [{ role: "user", content: prompt }],
       max_tokens: 8000,
       temperature: 0.2,
     },
     {
       headers: {
         Authorization: `Bearer ${this.gptApiKey}`,
         "Content-Type": "application/json",
       },
     }
   );
   return response.data.choices[0].message.content.trim();
 }

  }
};
</script>


<style>
.tour-router-container {
  background: #0a0e17;
  color: #fff;
}

.step-card {
  background: rgba(12, 22, 27, 0.95);
  padding: 24px;
  border-radius: 10px;
}

.tech-chip {
  background: #00ffe5;
  color: #000;
  width: 22px;
  text-align: center;
  font-weight: bold;
}

.city-input-row {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}

#tour-map {
  border: 1px solid #00ffe5;
  border-radius: 8px;
  margin-top: 16px;
}

.v-stepper {
  background: transparent;
}
.card-animate-2 {
  animation: animateCard 0.5s;
  backdrop-filter: blur(10px);
  background: rgba(0, 0, 0, 0.5);
  border-radius: 20px;
}
.tour-report {
  margin-top: 30px;
  padding: 30px 30px 30px 30px;
  background: #0f172a;
  border-radius: 20px;
  box-shadow: 0px 0px 5px #00eaff;
  color: white;
  max-width: 1000px;
  margin: auto;
  text-align: left;
}
.tour-ai-dashboard {
  background: #0c161bb6;
  color: white;
  min-height: 100vh;
  padding-top: 20px;
}
.tour-ai-dashboard::before {
  /* subtle animated grid */
  content: "";
  position: absolute;
  inset: 0;
  background-size: 0px 0px;
  animation: gridScroll 60s linear infinite;
  pointer-events: none;
  z-index: 9999;
}
@keyframes gridScroll {
  from { background-position: 0 0, 0 0; }
  to   { background-position: 0 40px, 40px 0; }
}
.report-header {
  background: #00eaff;
  color: black;
  padding: 15px;
  text-align: center;
  border-radius: 5px;
}

.report-header h2 {
  margin: 0;
  font-size: 24px;
}

.report-body {
  padding: 20px;
  background: rgba(20, 30, 50, 0.9);
  border-radius: 10px;
  margin-top: 10px;
}

.report-body h3 {
  color: #00eaff;
  font-size: 22px;
  margin-bottom: 10px;
}

.report-content {
  font-size: 18px;
  line-height: 1.6;
  white-space: pre-line;
}
.ai-question {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.download-btn {
  display: block;
  margin: 20px auto;
  padding: 12px 20px;
  font-size: 22px;
  background: #00eaff;
  color: black;
  border: none;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 5px;
  text-align: center;
  width: auto !important;
}

.download-btn:hover {
  background: #0088ff;
}

.chat-container {
  max-width: 100%;
  margin: 0 40px 0 40px;
  padding: 40px 20px 40px 20px;
  text-align: center;
  background: #0f172ab7;
  color: #00eaff;
  box-shadow: 0px 0px 20px #00eaff;
  border-radius: 0px;
}

.input-box {
  padding: 10px;
  font-size: 22px;
  width: 500px;
  background: #1e293b;
  border: 1px solid #00eaff;
  color: #00eaff;
  border-radius: 5px;
  text-align: center;
}

.ask-button, .add-btn, .remove-btn, .save-btn, .edit-btn {
  padding: 10px 20px 10px 20px;
  margin: 10px 20px 10px 20px;
  font-size: 20px;
  background: #00eaff;
  color: black;
  border: none;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 10px;
  margin-top: 10px;
  width: auto !important;
}

.ask-button:hover, .add-btn:hover, .remove-btn:hover, .save-btn:hover, .edit-btn:hover {
  background: #0088ff;
}

.city-list {
  margin-top: 20px;
}

.city-input {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
}

.remove-btn {
  background: #ff4c4c;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
}

.remove-btn:hover {
  background: #ff1c1c;
}

/* Style for Venue Results */
.venue-results {
  margin-top: 30px;
  padding: 40px 40px 40px 40px;
  background: rgba(30, 41, 59, 0.8);
  border: 2px solid #00eaff;
  border-radius: 10px;
  box-shadow: 0px 0px 15px #00eaff;
  text-align: left;
  font-size: 18px;
}

.venue-results h4 {
  text-align: center;
  color: #00eaff;
}

.venue-results ul {
  list-style: none;
  padding: 0;
}

.venue-results li {
  padding: 10px;
  background: #0a1a2e;
  border: 1px solid #00eaff;
  border-radius: 5px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.venue-link {
  color: #00eaff;
  text-decoration: none;
  margin-left: 10px;
}

.venue-link:hover {
  text-decoration: underline;
}

/* Saved Tours Section */
.saved-tours {
  margin-top: 30px;
  padding: 50px;
  background: rgba(20, 30, 50, 0.8);
  border: 2px solid #00eaff;
  border-radius: 10px;
  box-shadow: 0px 0px 15px #00eaff;
  text-align: left;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  font-size: 18px;

}

.saved-tours h4 {
  text-align: center;
  color: #00eaff;
}

.saved-tours ul {
  list-style: none;
  padding: 0;
}

.saved-tours li {
  padding: 10px;
  background: #0a1a2e;
  border: 1px solid #00eaff;
  border-radius: 5px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

/* Tour Map Container */
#tour-map {
  width: 100%;
  height: 800px;
  margin-top: 20px;
  border: 2px solid #00eaff;
  border-radius: 10px;
}

/* AI Response */
.ai-response {
  margin-top: 15px;
  padding: 10px;
  background: rgba(30, 41, 59, 0.8);
  border-radius: 5px;
  font-style: normal;
  color: white;
  text-align: center;
  font-size: 20px;
}

.input-group {
  margin-bottom: 20px;
  text-align: center;
  align-content: center;
  margin-left: 580px;
  width: 600px;
}
.ai-notification {
  color: white;
  background: rgba(0, 150, 255, 0.8);
  padding: 10px;
  text-align: center;
  border-radius: 5px;
}
.profile-card {
  cursor: pointer;
  padding: 10px;
  margin: 10px;
  border-radius: 5px;
  transition: 0.3s;
  display: inline-block;
}
.artist-profiles {
   display: flex;
   flex-wrap: wrap;
   gap: 20px;
   align-content: center;
    justify-content: center;
 }
  .album-container {
    position: relative;
    width: 120px;
    height: 120px;
    overflow: hidden;
    border-radius: 50%;
    margin: 0 auto;
  }

/* General layout */
form {
  margin: 20px 0;
}
.floating-legend {
 position: sticky;
 background: linear-gradient(135deg, rgba(8, 8, 24, 0.8), rgba(16, 16, 49, 0.8));
 color: white;
 padding: 1rem;
 margin-bottom: 20px;
 border-radius: 10px;
 box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
 min-width: 760px;
 max-width: 98%; /* Ensure it fits within the page */
 z-index: 9999;
 overflow: auto;
 animation: fadeIn 0.5s ease-in-out;
 cursor: move;
}

/* Data Summary Row */
.data-summary-row {
 display: flex;
 justify-content: space-between;
 align-items: center;
 margin-bottom: 1rem;
}

.data-summary-row p {
 margin: 0;
 padding: 0 10%;
 font-size: 1.2rem;
 font-weight: bold;
}

/* Data Status */
.data-status {
 margin-bottom: 0.5rem;
}

.data-status p {
 margin: 0;
 font-size: 0.85rem;
}

.data-status p.collected {
 color: limegreen;
 font-weight: bold;
}

.data-status p:not(.collected) {
 color: crimson;
 font-weight: bold;
}

/* AI Search Section */
.ai-search {
 margin-top: 1rem;
}

.ai-search p {
 font-weight: bold;
 margin-bottom: 0.5rem;
}

.ai-search v-btn {
 margin-right: 0.5rem;
}

/* Animations */
@keyframes fadeIn {
 from {
   opacity: 0;
   transform: scale(0.95);
 }
 to {
   opacity: 1;
   transform: scale(1);
 }
}

/* Responsive Adjustments */
@media (max-width: 768px) {
 .floating-legend {
   min-width: 100%;
   padding: 0.8rem;
 }

 .data-summary-row p {
   font-size: 0.8rem;
 }

 .data-status p {
   font-size: 0.75rem;
 }
}

@media (max-width: 480px) {
 .floating-legend {
   padding: 0.5rem;
 }

 .data-summary-row p {
   font-size: 0.7rem;
 }

 .data-status p {
   font-size: 0.65rem;
 }
}
/* Legend Header */
.legend-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 border-bottom: 1px solid rgba(255, 255, 255, 0.2);
 padding-bottom: 0.5rem;
 margin-bottom: 0.5rem;
}

.legend-header h3 {
 font-size: 1.2rem;
 margin: 0;
}

.legend-content {
 margin-top: 1rem;
}

/* Data Status List */
.data-status {
 margin-bottom: 0.5rem;
 display: flex;
 justify-content: space-between;
 align-items: center;
}

.data-status p {
 margin: 0;
 font-size: 0.9rem;
}

.data-status p.collected {
 color: limegreen;
 font-weight: bold;
 animation: collectedAnimation 1s ease-in-out;
}

.data-status p:not(.collected) {
 color: crimson;
 font-weight: bold;
 animation: pendingAnimation 1s ease-in-out;
}

/* AI Search Section */
.ai-search {
 margin-top: 1rem;
}

.ai-search p {
 font-weight: bold;
 margin-bottom: 0.5rem;
}

.ai-search v-btn {
 margin-right: 0.5rem;
}

/* Resize Handle */
.floating-legend::after {
 content: "";
 position: absolute;
 bottom: 0;
 right: 0;
 width: 20px;
 height: 20px;
 background: rgba(255, 255, 255, 0.2);
 cursor: nwse-resize;
}

/* Animations */
@keyframes fadeIn {
 from {
   opacity: 0;
   transform: scale(0.95);
 }
 to {
   opacity: 1;
   transform: scale(1);
 }
}

@keyframes collectedAnimation {
 from {
   color: gray;
   transform: scale(1.1);
 }
 to {
   color: limegreen;
   transform: scale(1);
 }
}

@keyframes pendingAnimation {
 from {
   color: gray;
   transform: scale(1.1);
 }
 to {
   color: crimson;
   transform: scale(1);
 }
}

/* Responsive Adjustments */
@media (max-width: 768px) {
 .floating-legend {
   width: 90%;
   padding: 0.8rem;
 }

 .legend-header h3 {
   font-size: 1rem;
 }

 .data-status p {
   font-size: 0.8rem;
 }
}

@media (max-width: 480px) {
 .floating-legend {
   width: 100%;
   padding: 0.5rem;
 }

 .legend-header h3 {
   font-size: 0.9rem;
 }

 .data-status p {
   font-size: 0.7rem;
 }
}

.save-btn {
 position: top-right;
 width: 100px;
 height: 100px;
 color: #fff;
 background: linear-gradient(90deg, #0c161b, #0c161b);
 top: 50px;
 left: 0px;
 opacity: 0.8;
}
.close-btn {
 position: top-right;
 width: 100px;
 height: 100px;
 color: #fff;
 background: linear-gradient(90deg, #0c161b, #0c161b);
 top: 50px;
 left: 10px;
 opacity: 0.8;
}
.overlay2 {
 background: rgba(0, 0, 0, 0.5);
 border: #000;
 border-radius: 10px;
 color: white;
 width: 100%;
 text-align: center;
 padding: 10px 10px;
}
.overlay {
 position: fixed;
 top: 0;
 left: 0;
 width: 100%;
 height: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 background-color: #0c161b2f; /* Semi-transparent background */
}
.inputarea {
 width: 100%;
 padding: 8px;
 border: 1px solid #ccc;
 border-radius: 10px;
 box-sizing: border-box;
 resize: vertical;
 font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
 font-size: 1.2rem;
 color: #000;
}
.loading-container {
 background: rgba(12, 22, 27, 0.4);
 border-color: #5a80bf;
 color: #efe;
 outline-width: 2px;
 padding: 5px;
 border-radius: 10px;
 margin: 10px;
 top: 160px;
 width: 800px;
 height: 600px;
 color: #fff;
 text-align: center;
 font-size: 1.3rem;
 font-weight: normal;
 font-family: 'Roboto', sans-serif;
}
@keyframes glow2 {
 0% {
   border-color: #00adb4;
   box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
 }

 100% {
   border-color: #78cce2;
   box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
 }
}
@media only screen and (max-width: 900px) {
.loading-container {
 background: rgba(12, 22, 27, 0.4);
 border-color: #5a80bf;
 color: #efe;
 outline-width: 2px;
 padding: 25px;
 border-radius: 10px;
 margin: 10px;
 top: 160px;
}
@keyframes glow2 {
 0% {
   border-color: #00adb4;
   box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
 }

 100% {
   border-color: #78cce2;
   box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
 }
}
}
textarea {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  resize: none;
}
body {
  font-family: Arial, sans-serif;
}
.floating-legend-2 {
 position: fixed;
 top: 11.5%;
 right: 25px;
 width: 100px;
 background-color: rgba(12, 22, 27, 0.2);
 border-radius: 10px;
 padding: 10px;
 box-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}
.expand-icon {
 cursor: pointer;
 src: url(https://cdn-icons-png.flaticon.com/512/1828/1828928.png);
}
.card-container {
 display: flex;
 flex-wrap: wrap;
 gap: 20px;
 justify-content: center;
 width: 1550px;
}
.card-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 10px;
 background: #3e2186;
 color: white;
 border-radius: 5px 5px 0 0;
}
.card-header h2 {
 margin: 0;
}
.card-content {
 padding: 20px;
 border-radius: 0 0 5px 5px;
}

.thermometer {
 width: 50px;
 height: 150px;
 background: #ccc;
 border-radius: 20px;
 overflow: hidden;
 margin: 0 auto 10px;
 position: relative;
}

.thermometer-fill {
 width: 100%;
 background: linear-gradient(to top, #ff0000, #00ff00);
 position: absolute;
 bottom: 0;
 transition: height 0.5s ease-in-out;
}

.legend {
 text-align: center;
 color: #fff;
}

.legend p {
 margin: 5px 0;
 opacity: 0.5;
 font-weight: normal;
 transform: scale(0.8);
 transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
}

.legend p.active {
 opacity: 1;
 font-weight: bold;
 transform: scale(1.1);
 color: #388e3c;
}
.profile-card.expanded {
  transform: scale(1.05);
  height: auto;
}
/* .profile-card2 {
  border: 2px solid #3e2186;
  border-radius: 50%;
  padding: 10px;
  margin: 10px 0;
  transition: transform 0.3s ease, height 0.3s ease;
  overflow: hidden;
  cursor: pointer;
  width: 200px;
  height: 200px;
} */
.profile-card2.expanded {
  transform: scale(1.05);
  border-radius: 5%;
  height: auto;
  padding: 30px 30px 30px 30px;
  margin: 10px 10px 10px 10px;
  transition: transform 0.3s ease, height 0.3s ease;
  overflow: hidden;
  cursor: pointer;
  width: 500px;
  background: rgba(25, 12, 31, 0.503);
}
.artist-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
}


.progress-tracker {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  cursor: pointer;
}
.progress-step {
  flex: 1;
  text-align: center;
  padding: 10px;
  background-color: #edefeb;
  color: #333;
  margin: 0 5px;
  border-radius: 10px;
}
.progress-step.active {
  background-color: #4caf50;
  color: white;
}
.form-control-6 {
  margin-bottom: 20px;
}

.news-articles {
  display: flex;
  flex-wrap: wrap;
}
.article-card {
  width: 200px;
  margin: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  transition: transform 0.3s ease;
}
.article-card:hover {
  transform: scale(1.1);
}

/* Buttons */
button {
  background-color: #4caf50;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
button:hover {
  background-color: #45a049;
}
.artistName {
  color: #78b59c;
  font-size: 18px;
  font-family: 'lato';
  font-weight: thin;
  font-stretch: expanded;
  text-align: center;
  left: 0%;
  right: 0px;
  margin-right: 30px;
  padding-block: 10px;
  padding-left: 10px;
  padding-right: 10px;
  text-decoration: none !important;
  outline-width: 1px;
  outline-color: #a8abb1;
    outline-style: solid;
    border-radius: 15px;
    animation: glow 2500ms ease-out infinite alternate;
    box-shadow: 0 0 3px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
}
@keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
  .artist-profiles {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.profile-card2 {
  position: relative;
  width: 300px;
  height: 280px;
  padding: 16px;
  background: rgba(44, 53, 58, 0.973);
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  overflow: hidden;
  cursor: pointer;
}

.profile-card2 h3 {
  margin-top: 16px;
}

/* Album and Vinyl Styles */
.album-container {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.album-cover {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2; /* Above the vinyl */
  border-radius: 4px;
  overflow: hidden;
  outline: 1px solid #ffffff64;
  animation: glow 1800ms ease-out infinite alternate;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.6);
}


.cover-image2 {
  width: 100%;
  height: 100%;
  object-fit: fill;
  margin-top: 0px;
}
.vinyl-record {
  position: absolute;
  top: 0;
  left: 200px;
  width: 200px; /* Match the album cover size */
  height: 200px;
  z-index: 1; /* Behind the album cover */
  transform: translateX(-100%); /* Start hidden behind the cover */
  transition: transform 1s ease-in-out;
}

.vinyl-record.slide-out {
  transform: translateX(-80px); /* Adjust this value based on desired slide distance */
}

.vinyl-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  animation: spinVinyl 5s linear infinite;
}

/* Vinyl Spinning Animation */
@keyframes spinVinyl {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.profile-card3 {
  background: rgba(255, 255, 255, 0.1);
  padding: 20px 20px 20px 20px;
  color: #fff;
  border-radius: 20px;
  text-align: left;
  width: 100%;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 255, 255, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
  outline-width: 2px;
  outline-color: #5a80bf;
    outline-style: solid;
    border-radius: 10px;
    animation: glow 1800ms ease-out infinite alternate;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
}
@keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
  

.profile-card {
  background: rgba(255, 255, 255, 0.1);
  padding: 20px 20px 20px 20px;
  color: #fff;
  border-radius: 20px;
  text-align: left;
  width: 100%;
  width: 740px;
  box-shadow: 0 4px 8px rgba(0, 255, 255, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
  outline-width: 2px;
  outline-color: #5a80bf;
    outline-style: solid;
    border-radius: 10px;
    animation: glow 1800ms ease-out infinite alternate;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
}
@keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
.inputarea2:focus {
  border-color: #6200ea;
  outline: none;
  box-shadow: 0 0 8px rgba(98, 0, 234, 0.5);
  font-size: 16px;
  color: white;
}

.inputarea2 {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  resize: none;
}

.artist-image-container {
  text-align: center;
  margin-top: 10px;
}

.artist-image {
  width: 225px;
  height: 225px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.form-group {
  margin-top: 10px;
}

.v-btn {
  margin-left: 5px;
}

.saved-queries-container {
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 10px;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

/* Grid styling for saved queries */
.saved-queries-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

/* Individual query card styling */
.saved-query-card {
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 10px;
  text-align: left;
  width: 100%;
  max-width: 300px;
  box-shadow: 0 4px 8px rgba(0, 255, 255, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
}

.saved-query-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 255, 255, 0.4);
}

/* Action buttons in query cards */
.action-buttons {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

/* Responsive design */
@media screen and (max-width: 768px) {
  .saved-query-card {
    width: 100%;
  }
}

/* Text fields and buttons */
.v-text-field {
  margin-bottom: 20px;
  color: white;
  background: rgb(255, 255, 255);
  text-transform: normal;
  font-weight: light;
}

.v-btn {
  margin: 5px;
  background: rgba(27, 13, 46, 0);
  color: #000000;
  text-transform: uppercase;
  font-weight: bold;
}

.v-btn:hover {
  background: rgba(27, 13, 46, 0.551);
  color: #fff;
}

/* Loading and found data message */
.loading-container {
  text-align: center;
  margin-top: 20px;
  font-size: 18px;
  color: #6200ea;
}
.activeButton {
 background: linear-gradient(135deg, rgba(98, 0, 234, 0.8), rgba(156, 39, 176, 0.6));
 color: #fff;
 border: 2px solid rgba(156, 39, 176, 0.8);
 border-radius: 12px;
 padding: 12px 24px;
 cursor: pointer;
 font-size: 1rem;
 font-weight: bold;
 text-transform: uppercase;
 text-shadow: 0 0 8px rgba(255, 255, 255, 0.8);
 box-shadow: 0 0 15px rgba(98, 0, 234, 0.8), 0 0 25px rgba(156, 39, 176, 0.7);
 outline: none;
 transition: transform 0.3s ease, box-shadow 0.3s ease;
 animation: pulseAnimation 5s infinite, wiggleAnimation 5s infinite;
}

/* Hover Effect */
.activeButton:hover {
 transform: scale(1.1);
 box-shadow: 0 0 25px rgba(98, 0, 234, 1), 0 0 35px rgba(156, 39, 176, 1);
}

/* Active State */
.activeButton:active {
 transform: scale(0.95);
 box-shadow: 0 0 20px rgba(98, 0, 234, 0.9), 0 0 30px rgba(156, 39, 176, 0.8);
}

/* Pulse Animation */
@keyframes pulseAnimation {
 0% {
   box-shadow: 0 0 15px rgba(98, 0, 234, 0.8), 0 0 25px rgba(156, 39, 176, 0.7);
 }
 50% {
   box-shadow: 0 0 25px rgba(98, 0, 234, 1), 0 0 35px rgba(156, 39, 176, 1);
   transform: scale(1.05);
 }
 100% {
   box-shadow: 0 0 15px rgba(98, 0, 234, 0.8), 0 0 25px rgba(156, 39, 176, 0.7);
 }
}

/* Wiggle Animation */
@keyframes wiggleAnimation {
 0%, 100% {
   transform: rotate(0deg);
 }
 25% {
   transform: rotate(2deg);
 }
 50% {
   transform: rotate(-2deg);
 }
 75% {
   transform: rotate(1deg);
 }
}

.found-data-message {
  margin-top: 10px;
  padding: 10px;
  background-color: #e8f5e9;
  color: #388e3c;
  border: 1px solid #81c784;
  border-radius: 8px;
  font-weight: bold;
}

/* Form card layout */

.chart-content-5 {
  background: rgba(0, 0, 0, 0.7);
  padding-block: 20px;
  border-radius: 10px;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

/* Responsive design */
@media screen and (max-width: 768px) {
  textarea {
    font-size: 14px;
  }

  .v-btn {
    font-size: 14px;
    padding: 8px 16px;
  }

  .v-text-field {
    margin-bottom: 15px;
  }

  .chart-content-5 {
    padding: 15px;
  }
}

.top-artists-container {
  margin-top: 20px;
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.artist-card {
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  width: 100%;
  max-width: 1860px;
  box-shadow: 0 4px 8px rgba(0, 255, 255, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
}

.artist-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
}
@media screen and (max-width: 576px) {
  .chart-content-5 {
    padding: 10px;
  }
  .v-btn {
    font-size: 12px;
    padding: 5px 10px;
  }
}
main{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    flex-basis: 60%;
    margin-left: auto;
    padding-bottom: 60px;
}

h1, p, h3{
    display: block;
    margin: 20px 10px 20px 10px;
    width: 100%;
}

h2{
    margin-left: 10px;
}

h3{
    text-align: center;
}

.news-search {
  color: #78b59c;
  font-size: 20px;
  font-family: 'lato';
  margin-top: -40px;
  border-radius: 20px;
}
.news-search2 {
  color: #78b59c;
  font-size: 20px;
  font-family: 'lato';
  background-color: rgba(12, 22, 27, 0.705);
  max-width: 1900px;
  padding: 100px 50px 50px 50px;
  margin-top: 20px;
  border-radius: 20px;
}
.news-search3 {
  color: #78b59c;
  font-size: 20px;
  font-family: 'lato';
  background-color: rgba(12, 22, 27, 0.705);
  max-width: 1900px;
  padding: 100px 50px 50px 50px;
  margin-top: 20px;
  border-radius: 20px;
}

form {
  margin-bottom: 0px;
}

form div {
  margin-bottom: 10px;
}

button {
  padding: 10px 20px;
  cursor: pointer;
}

.results {
  margin-top: 20px;
}

.article {
  flex-basis: 50%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    background: rgba(12, 22, 27, 0.9);
    padding-bottom: 20px;
    padding-top: 20px;
    padding-block: 40px 40px 40px 40px;
    margin-block: 40px 40px 40px 40px;
    -webkit-box-shadow: 5px 5px 5px 5px #7D7D7D; 
    box-shadow: 5px 5px 5px 5px #7D7D7D;
    hyphens: auto;
}

.article-image {
  width: 100%;
    height: 220px;
    object-fit: cover;
    object-position: center;
}

.prediction-animation {
  text-align: center;
  margin: 20px;
}
.neural-network {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.node {
  width: 15px;
  height: 15px;
  margin: 5px;
  background-color: #4caf50;
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    background-color: #4caf50;
  }
  50% {
    transform: scale(1.5);
    background-color: #81c784;
  }
}
.domainSelect {
  padding-block: 22px;
  margin-right: 22px;
  margin-left: 22px;
}

.textNews {
  color: #78b59c;
  font-size: 22px;
  font-family: 'lato';
  font-weight: thin;
  position: relative;
  left: 0%;
  right: 0px;
  margin-left: 20px;
}

.textNews2 {
  color: #fff;
  font-size: 22px;
  font-family: 'lato';
  font-weight: thin;
  position: relative;
  left: 0%;
  right: 0px;
  padding-right: 70px;
}

.textNews3 {
  color: #78b59c;
  font-size: 18px;
  font-family: 'lato';
  font-weight: thin;
  position: relative;
  left: 0%;
  right: 0px;
  margin-right: 30px;
  padding-block: 10px;
  padding-left: 10px;
  padding-right: 10px;
  text-decoration: none !important;
  outline-width: 2px;
  outline-color: #5a80bf;
    outline-style: solid;
    border-radius: 10px;
    animation: glow 1800ms ease-out infinite alternate;
    cursor: pointer;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
}
@keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
  .textNews4 {
  color: #78b59c;
  font-size: 26px;
  font-family: 'lato';
  font-weight: bold;
  position: relative;
  left: -46%;
  right: 0px;
}
.buttonNews {
  text-decoration: none !important;
  background: #78b59c;
  border-radius: 20px;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 0px;
  width: 250px;
  border: outline;
  opacity: 01;
  cursor: pointer;
  margin-left: 0px;
  margin-right: auto;
  left: 0px;
  right: 0px;
  outline-color: #5a80bf;
  align-content: center;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

@media only screen and (max-width: 600px) {
  
.buttonNews {
  text-decoration: none !important;
  border-radius: 40px;
  padding: 20px;
  width: 10px;
  border: outline;
  opacity: 0.9;
  cursor: pointer;
  margin-left: 0px;
  margin-right: auto;
  left: 0px;
  right: 0px;
  align: center;
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
}
.mainNews{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    flex-basis: 60%;
    margin-left: auto;
    padding-bottom: 60px;
}
.to-top{
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 10;
}

#to-top-image{
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: palegreen;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yNCAxMmMwIDYuNjIzLTUuMzc3IDEyLTEyIDEycy0xMi01LjM3Ny0xMi0xMiA1LjM3Ny0xMiAxMi0xMiAxMiA1LjM3NyAxMiAxMnptLTEgMGMwIDYuMDcxLTQuOTI5IDExLTExIDExcy0xMS00LjkyOS0xMS0xMSA0LjkyOS0xMSAxMS0xMSAxMSA0LjkyOSAxMSAxMXptLTExLjUtNC44MjhsLTMuNzYzIDQuNjA4LS43MzctLjY3OSA1LTYuMTAxIDUgNi4xMTItLjc1My42NjYtMy43NDctNC42MDR2MTEuODI2aC0xdi0xMS44Mjh6Ii8+PC9zdmc+");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 75%;
}

#to-top-image:hover{
    cursor: pointer;
    background-color: rgb(133, 223, 133);
}

.spinner {
 width: 50px;
 height: 50px;
 border: 5px solid #ccc;
 border-top: 5px solid #4caf50;
 border-radius: 50%;
 animation: spin 1s linear infinite;
}

/* Backdrop Animation */
.loading-backdrop {
 position: absolute;
 width: 300%;
 height: 300%;
 background: radial-gradient(circle, #007bff, #001f3f);
 animation: pulse 5s infinite alternate;
 opacity: 0.5;
 z-index: 0;
}

@keyframes pulse {
 0% {
   transform: scale(1);
   opacity: 0.4;
 }
 100% {
   transform: scale(1.5);
   opacity: 0.8;
 }
}

/* Loading Spinner */
.loading-container {
 z-index: 1;
 text-align: center;
}

.spinner {
 width: 80px;
 height: 80px;
 border-radius: 50%;
 border: 4px solid transparent;
 border-top: 4px solid #4caf50;
 position: relative;
 animation: spin 1s linear infinite;
}

.spinner-inner {
 position: absolute;
 width: 60px;
 height: 60px;
 top: 10px;
 left: 10px;
 border-radius: 50%;
 border: 4px solid transparent;
 border-top: 4px solid #ffc107;
 animation: spinReverse 1.5s linear infinite;
}

@keyframes spin {
 0% {
   transform: rotate(0deg);
 }
 100% {
   transform: rotate(360deg);
 }
}

@keyframes spinReverse {
 0% {
   transform: rotate(0deg);
 }
 100% {
   transform: rotate(-360deg);
 }
}
.step-section {
 margin-top: -20px;
 padding: 80px;
 background: rgba(12, 22, 27, 0.8);
 border-radius: 8px;
 color: #fff;
}

/* Notification Popup */
.popup-card {
 position: fixed;
 top: 10%;
 left: 50%;
 transform: translateX(-50%);
 z-index: 1000;
 background: #444;
 color: #fff;
 padding: 10px 20px;
 border-radius: 5px;
 animation: fadeInOut 5s forwards;
}

@keyframes fadeInOut {
 0% {
   opacity: 0;
 }
 10% {
   opacity: 1;
 }
 90% {
   opacity: 1;
 }
 100% {
   opacity: 0;
 }
}


/* Loading Indicator */
.loading-overlay {
 position: fixed;
 top: 0;
 left: 0;
 width: 100%;
 height: 100%;
 background: rgba(0, 0, 0, 0.7);
 display: flex;
 justify-content: center;
 align-items: center;
 text-align: center;
 z-index: 1000;
 animation: fadeInOut 5s forwards;
}

.spinner {
 width: 50px;
 height: 50px;
 border: 5px solid #ccc;
 border-top: 5px solid #4caf50;
 border-radius: 50%;
 animation: spin 1s linear infinite;
}

@keyframes spin {
 0% {
   transform: rotate(0deg);
 }
 100% {
   transform: rotate(360deg);
 }
}
.loading-container h3 {
 margin-top: 20px;
 color: #fff;
 font-size: 1.2em;
 font-weight: 500;
 letter-spacing: 1px;
}

.error-popup {
 background: #ff4d4d;
}

.notification-popup {
 background: #4caf50;
}

/* Transitions */
.fade-enter-active, .fade-leave-active {
 transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
 opacity: 0;
}
.card-animate-2 {
  animation-name: slideExpandUp;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 3s;
  transition: opacity 1s Elastic.easeIn;
}
</style>
